/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, ElementRef, Injector, SkipSelf} from '@angular/core';

import {AbstractPopover} from '../../popover/common/abstract-popover';
import {Point} from '../../popover/common/popover';
export class TabOverflowContent extends AbstractPopover {
/**
 * @param {?} injector
 * @param {?} parentHost
 */
constructor(injector: Injector,  parentHost: ElementRef) {
        super(injector, parentHost);
        this.anchorPoint = Point.BOTTOM_RIGHT;
        this.popoverPoint = Point.RIGHT_TOP;
        this.closeOnOutsideClick = true;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-tab-overflow-content",
    template: `
        <ng-content></ng-content>
    `,
    host: {
        "[class.dropdown-menu]": "true",
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
{type: ElementRef, decorators: [{ type: SkipSelf }, ]},
];
}

function TabOverflowContent_tsickle_Closure_declarations() {
/** @type {?} */
TabOverflowContent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabOverflowContent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
